import React, { memo } from 'react'
import styles from './reset.styles'
import injectSheet from 'react-jss'
import ResetIcon from 'react-icons/lib/fa/refresh'
import classNames from 'classnames'
import { withPresentation } from '../../../../presentation-connectors'

const Reset = memo(({ classes, className, onClick }) => (
  <span onClick={onClick} className={classNames(classes.container, className)}>
    <ResetIcon className={classes.icon} />
    <span>Reset answers</span>
  </span>
))

export default withPresentation(injectSheet(styles)(Reset))
